export default __webpack_public_path__ + "static/media/icons-coins.bce41e10.svg";